import React from "react";

/**
 * Aadiyogis logo — SVG recreation of the ornate gold oval frame
 * with center "A" monogram. Watermark-free, scalable, theme-aware.
 *
 * Props:
 *  - size: pixel height of the emblem (default 40)
 *  - variant: "light" (gold on any bg, for dark backgrounds)
 *             "dark" (dark green on any bg, for light backgrounds)
 *  - withWordmark: renders "AADIYOGIS EXIM" wordmark to the right
 *  - className: extra classes for wrapper
 */
export default function Logo({
  size = 40,
  variant = "dark",
  withWordmark = true,
  className = "",
}) {
  const isDarkVariant = variant === "light";
  const strokeColor = "#C5A059";
  const monogramColor = isDarkVariant ? "#E6C97A" : "#1A3626";
  const wordmarkColor = isDarkVariant ? "#FFFFFF" : "#1A3626";
  const accentColor = "#C5A059";

  // Build a spirograph/guilloché lattice via rotated ellipses.
  const strands = 22;
  const rx = 60;
  const ry = 82;

  return (
    <div className={`flex items-center gap-3 ${className}`} aria-label="Aadiyogis EXIM Traders">
      <svg
        width={size}
        height={size * 1.15}
        viewBox="0 0 160 184"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
      >
        <g transform="translate(80 92)" stroke={strokeColor} strokeWidth="0.6" opacity="0.9">
          {Array.from({ length: strands }).map((_, i) => {
            const angle = (180 / strands) * i;
            return (
              <ellipse
                key={i}
                cx="0"
                cy="0"
                rx={rx}
                ry={ry}
                transform={`rotate(${angle})`}
                fill="none"
              />
            );
          })}
          {/* Outer oval accent */}
          <ellipse cx="0" cy="0" rx={rx + 2} ry={ry + 2} stroke={strokeColor} strokeWidth="1.2" fill="none" opacity="0.6" />
        </g>

        {/* Center serif A */}
        <text
          x="80"
          y="108"
          textAnchor="middle"
          fontFamily="'Cormorant Garamond', 'Times New Roman', serif"
          fontSize="54"
          fontWeight="600"
          fill={monogramColor}
          style={{ letterSpacing: "0" }}
        >
          A
        </text>
      </svg>

      {withWordmark && (
        <div className="flex flex-col leading-none">
          <span
            className="font-serif-display tracking-[0.14em] font-semibold"
            style={{ color: wordmarkColor, fontSize: size * 0.42 }}
          >
            AADIYOGIS
          </span>
          <span
            className="mt-1 tracking-[0.32em] font-medium"
            style={{ color: accentColor, fontSize: size * 0.22 }}
          >
            EXIM TRADERS
          </span>
        </div>
      )}
    </div>
  );
}
